export default __webpack_public_path__ + "static/topic4-2a0ab361e87584f4703854c7a6935add.png";